import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { responseHandler } from "@msuite/ui/utils";
import { type WarehouseZoneFormSchema, warehouseZoneFormSchema } from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { WarehouseZoneForm } from "@/forms/warehouse-zone-form";
import { client } from "@/hono";

/** Props Interface */
interface AddWarehouseZoneModalProps extends ModalProps {
	onComplete?: () => Promise<void>;
}

export function AddWarehouseZoneModal({ onClose, isOpen, onComplete }: AddWarehouseZoneModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(warehouseZoneFormSchema),
		defaultValues: {
			type: "storage",
		},
	});

	/** Functions */
	async function handleOnSubmit(json: WarehouseZoneFormSchema) {
		const response = await client.stock["warehouse-zones"].$post({ json });
		await responseHandler(response);
		await onComplete?.();
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				title={t("stock.add_warehouse_zone")}
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={methods.handleSubmit(handleOnSubmit, console.error)}
			>
				<Modal.Body>
					<WarehouseZoneForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
